module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIGITAL_ADAPTED_STYLE.ffb270b6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIGITAL_ADAPTED_STYLE.png
// module id = 1147
// module chunks = 16